import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { isAdminPortalEmail } from "../config/adminPortalAccess";

const AdminPortalRoutes = () => {
  const { isAuth, email } = useSelector((state) => state.auth);

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  if (!isAdminPortalEmail(email)) {
    return <Navigate to="/dashboard/homepage" />;
  }

  return <Outlet />;
};

export default AdminPortalRoutes;
